import React from "react";
import "./profile.css";

/** Light toolbar at the top of a profile section: optional title, status message and action buttons. */
export const SectionToolbar = ({ title, icon, statusMsg, children }) => (
  <div className="profile-toolbar">
    {title ? (
      <div className="profile-toolbar-title">
        {icon && <i className={`bi ${icon}`}></i>}
        {title}
      </div>
    ) : null}
    <div className="profile-toolbar-actions">
      {statusMsg?.text && (
        <span className={`profile-status text-${statusMsg.type}`} role="status">
          <i
            className={`bi ${statusMsg.type === "success" ? "bi-check-circle-fill" : "bi-exclamation-triangle-fill"}`}
          ></i>
          {statusMsg.text}
        </span>
      )}
      {children}
    </div>
  </div>
);

/** Edit button in view mode; Save + Cancel buttons in edit mode. */
export const EditActions = ({
  isEditing,
  onEdit,
  onSave,
  onCancel,
  isSaving = false,
}) =>
  !isEditing ? (
    <button type="button" className="btn btn-dark profile-btn" onClick={onEdit}>
      <i className="bi bi-pencil-square"></i> Edit
    </button>
  ) : (
    <>
      <button
        type="button"
        className="btn btn-outline-secondary profile-btn"
        onClick={onCancel}
        disabled={isSaving}
      >
        <i className="bi bi-x-lg"></i> Cancel
      </button>
      <button
        type="button"
        className="btn btn-success profile-btn"
        onClick={onSave}
        disabled={isSaving}
      >
        {isSaving ? (
          <span
            className="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        ) : (
          <i className="bi bi-check-lg"></i>
        )}
        Save
      </button>
    </>
  );

/** Green "Add" button used by table sections. */
export const AddButton = ({ onClick, disabled, label = "Add" }) => (
  <button
    type="button"
    className="btn btn-success profile-btn"
    onClick={onClick}
    disabled={disabled}
  >
    <i className="bi bi-plus-circle"></i> {label}
  </button>
);

/** Light sub-heading used to group fields inside a section. */
export const SubHeader = ({ title, icon, children }) => (
  <div className="profile-subheader">
    <span>
      {icon && <i className={`bi ${icon}`}></i>}
      {title}
    </span>
    {children}
  </div>
);
